import * as React from 'react';
import SmMaking, { MakingProps } from 'containers/SmWorkbench/ProjectDetail/Show/Detail/Bottom/Making';

export default class Making extends React.Component<MakingProps> {
  render() {
    return (
      <SmMaking
        {...this.props}
        templateDownloadUrl="outsource/ls/projects/download_case_template"
      />
    );
  }
}
